module.exports = __webpack_public_path__ + "img/36_79.dae807e2.png";